import { Component } from '@angular/core';
import { HttpService } from '../services/httpService';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent {

  complete: boolean = false;



  loading: boolean = false;

  error: boolean = false;
  message = '';


  fullName = '';
  email = '';
  phone = '';
  name = '';
  locations = 0;
  note = '';
  constructor(private httpService: HttpService, public router: Router, private activeRoute: ActivatedRoute) {

   

  }
  submit() {



    if (this.fullName.length < 3) { this.error = true; this.message = 'Enter valid full name' }
    else if (this.checkEmail(this.email) == false) { this.error = true; this.message = 'Enter valid email' }
    else if (this.phone.length != 10) { this.error = true; this.message = 'Enter valid 10 digit US contact phone' }
    else if (this.name.length < 3) { this.error = true; this.message = 'Enter valid business name' }
    else if (this.locations == 0) { this.error = true; this.message = 'Enter number of business locations' }
    else if (this.note.length < 3) { this.error = true; this.message = 'Type a note' }
    else {
      this.loading = true;

      this.error = false;



      const request = {
        FullName: this.fullName,
        Email: this.email,
        Phone: this.phone,
        Name: this.name,
        Locations: this.locations,
        Note: this.note

      }

      this.httpService.post<any>('Store/create-contact', request, false).subscribe(
        resp => {

          if (JSON.parse(resp.message).message == 'success') {
            this.complete = true;
            window.scroll(0, 0);
            this.router.navigate(['/schedule', 'sales']);

          }




          this.loading = false;


        },
        error => {
          this.loading = false;

          console.log(error);

          //this.snackbarService.show('Oh no! That email or password was incorrect.');
        });





    }

  }












  checkEmail(chunk) {

    var emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!emailReg.test(chunk)) {
      //alert('Enter valid email');
      return false;
    }

    return true;
  }


}
